import { createFileRoute } from '@tanstack/react-router';
import { GuidedHomeworkPage } from '@/features/learning/student/GuidedHomeworkPage';
export const Route = createFileRoute('/_authed/learning/$workId')({
  component: function HomeworkRoute() {
    const { workId } = Route.useParams();
    return <GuidedHomeworkPage key={workId} workId={workId} />;
  },
});
